class Settings {
    constructor() {
        if (!this.instance) {
            this.instance = this
            this.settings = {}
        }
        return this.instance
    }

    storeSettings(settings) {
        this.settings = settings || {};

        this.origin = settings.origin
        // TODO: Prefix settings.origin to anything ending in Url, and just copy everything?
        this.gatewayServiceUrl = new URL(settings.gatewayServiceUrl, settings.origin).href
        this.logoutUrl = new URL(settings.logoutUrl, settings.origin).href
        this.grafanaUrl = new URL(settings.grafanaUrl, settings.origin).href
        this.baseTileUrl = new URL(settings.baseTileUrl, settings.origin).href

        this.maxRadiosToFetch = settings.maxRadiosToFetch
        this.purgeSPRRouteFieldsDays = settings.purgeSPRRouteFieldsDays
        this.tileProvider = settings.tileProvider
    }
}

export default new Settings()
